module.exports = __webpack_public_path__ + "static/img/22.676bf439.png";